<template>
  <v-pagina-de-apresentacao>
    <template v-slot:main-content>
      <div class="text-center accent--text text-h4 mt-n4">
        Cadastre-se agora mesmo
      </div>
      <v-card class="elevation-7 pa-8 mt-2" rounded="lg" color="accent">
        <div flat color="accent">
          <v-toolbar-title class="text-h5"
            >Informações pessoais</v-toolbar-title
          >
        </div>
        <ValidationObserver v-slot="{ invalid }">
          <v-form @submit.prevent="onSubmit" ref="form" lazy-validation>
            <v-card-text>
              <ValidationProvider
                name="Name"
                rules="required"
                v-slot="{ errors, valid }">
                <v-text-field
                  type="text"
                  label="Nome"
                  name="nome"
                  prepend-icon="person"
                  required
                  v-model="username"
                  :error-messages="errors"
                  :success="valid" />
              </ValidationProvider>
              <ValidationProvider
                name="Email"
                rules="required|email"
                v-slot="{ errors, valid }">
                <v-text-field
                  label="Email"
                  name="email"
                  prepend-icon="email"
                  type="text"
                  required
                  v-model="email"
                  :error-messages="errors"
                  :success="valid" />
              </ValidationProvider>
              <ValidationProvider
                name="Senha"
                rules="required|min:6"
                vid="confirmation"
                v-slot="{ errors, valid }">
                <v-text-field
                  label="Senha"
                  name="password"
                  prepend-icon="lock"
                  type="password"
                  required
                  v-model="password"
                  :error-messages="errors"
                  :success="valid" />
              </ValidationProvider>
              <ValidationProvider
                name="Conf"
                rules="required|min:6|confSenha:confirmation"
                v-slot="{ errors, valid }">
                <v-text-field
                  label="Confirmação de senha"
                  name="password"
                  prepend-icon="mdi-lock-check"
                  type="password"
                  v-model="passwordConfirmation"
                  required
                  :error-messages="errors"
                  :success="valid" />
              </ValidationProvider>
              Já é cadastrado?
              <router-link :to="{ name: 'login' }">Entre aqui.</router-link>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                type="submit"
                color="primary"
                block
                large
                :loading="loading"
                :disabled="invalid"
                >Enviar</v-btn
              >
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </template>
  </v-pagina-de-apresentacao>
</template>

<script>
import VPaginaDeApresentacao from "@/layouts/PaginaDeApresentacao"
import { ValidationObserver, ValidationProvider } from "vee-validate"
import { mapActions } from "vuex"

import messageMixin from "@/mixins/translateMessageMixin"

const USUARIO_CADASTRADO = "Usuário cadastrado com sucesso."

export default {
  components: { ValidationObserver, ValidationProvider, VPaginaDeApresentacao },
  mixins: [messageMixin],
  data: () => ({
    loading: false,
    username: "",
    email: "",
    password: "",
    passwordConfirmation: "",
  }),
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store
          .dispatch("auth/register", {
            username: this.username,
            email: this.email,
            password: this.password,
          })
          .then((res) => {
            if (res.status == 200) {
              this.showSucesso(USUARIO_CADASTRADO)
              this.$router.push("/login")
            } else {
              this.showErro(this.getMessage(res.data.error.message))
            }
          })
          .catch(({ response }) => {
            this.showErro(this.getMessage(response.data.error.message))
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    ...mapActions("message", ["showSucesso", "showErro"]),
  },
}
</script>
